// React Imports
import * as React from "react";
import {useState, useEffect} from "react";
import {useDispatch, useSelector} from "react-redux";
import {useForm} from "react-hook-form";

// Mui Imports
import {
    GridToolbarColumnsButton,
    GridToolbarContainer, GridToolbarDensitySelector, GridToolbarExport,
} from '@mui/x-data-grid';
import IconButton from "@mui/material/IconButton";
import EditIcon from "@mui/icons-material/Edit";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import {DataGridPro, GRID_DETAIL_PANEL_TOGGLE_FIELD} from "@mui/x-data-grid-pro";
import Box from "@mui/material/Box";
import {
    Avatar, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle,
    Drawer,
    ListItemIcon,
    ListItemText, Stack, TextField,
    Tooltip
} from "@mui/material";
import {blue, deepOrange, deepPurple, teal} from "@mui/material/colors";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import Typography from "@mui/material/Typography";

// App Imports
import {
    addNewFilterLevel,
    deleteContractDataPointValueFilter, extendLastFilterLevel, getCDPVFbyCDPid, updateCdpvfHierarchy
} from "../../ContractDataPointValueFilter/ContractDataPointValueFilterClient";
import KeyboardDoubleArrowRightIcon from '@mui/icons-material/KeyboardDoubleArrowRight';
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import {changeContractDrilldownCDP} from "../ContractDrilldownCDP/contractDrilldownSliceCDP";
import {changeCrudSnackbar} from "../../CommonComponents/crudSnackbarSlice";
import {
    deleteContractDataPointValue,
    getCDPVbyCDPVFid
} from "../../ContractDataPointValue/ContractDataPointValueClient";
import {changeContractDataPointValue} from "../../ContractDataPointValue/contractDataPointValueSlice";
import {changeContractDataPointValueFilter} from "../../ContractDataPointValueFilter/contractDataPointValueFilterSlice";
import {changeContractDrilldownCDPV} from "../ContractDrilldownCDPV/contractDrilldownSliceCDPV";
import ContractDataPointValueDrawer from "../../ContractDataPointValue/ContractDataPointValueDrawer";
import ContractDataPointValueFilterDrawer from "../../ContractDataPointValueFilter/ContractDataPointValueFilterDrawer";
import {changeContractDrilldownCDPVF} from "./contractDrilldownSliceCDPVF";
import Button from "@mui/material/Button";
import {changeContractDataPoint} from "../../ContractDataPoint/contractDataPointSlice";


// main function
export default function ContractDrilldownCDPVFGrid(props) {


    // ****************** BEGIN STATES ****************************

    const [allCDPVFs, setAllCDPVFs] = useState([]);
    const [showCdpvGrid, setShowCdpvGrid] = useState(false);
    const [showToolbar, setShowToolbar] = useState(false);

    // ****************** END STATES ****************************


    // *********************** BEGIN STORE ********************************

    const selectorCDPid = useSelector((state) => state.contractDrilldownSlcCDP.value.id);
    const selectorCdpDataPointName = useSelector((state) => state.contractDataPointSlc.value.dataPointName);
    const selectorCdpvfId = useSelector((state) => state.contractDrilldownSlcCDPVF.value.id);
    const selectorCdpvCount = useSelector((state) => state.contractDataPointValueSlc.value.cdpvCount);
    const controlCdpvDrawerState = useSelector((state) => state.contractDrilldownSlcCDPVF.value.cdpvDrawerState);
    const selectorCdpvId = useSelector((state) => state.contractDrilldownSlcCDPVF.value.cdpvId);
    

    // ********************** END STORE ********************************


    // ****************** BEGIN DISPATCH ****************************

    const dispatchData = useDispatch();

    // ****************** END DISPATCH ****************************



    // ****************** BEGIN FETCH ****************************

    const fetchDrilldownCDPVF = () =>
        getCDPVFbyCDPid(selectorCDPid)

            .then(data => {
                console.log(data);
                // setDrilldownCDPVF(data);
                setAllCDPVFs(data);
                console.log("This is my item used for the grid rows...");
                console.log(allCDPVFs);
            })

    // ****************** END FETCH ****************************


    // ******************** BEGIN USE EFFECTS *******************

    useEffect(() => {
        fetchDrilldownCDPVF();
        console.log("This is my refresh of the cdpvf grid")
        dispatchData(changeContractDrilldownCDPVF({cdpvfGridRefresh: false,cdpvfGridState: true}));
    }, [useSelector((state) => state.contractDrilldownSlcCDPVF.value.cdpvfGridRefresh)===true]);


    useEffect(() => {
        handleRebuildHierarchy();
        console.log("This is my rebuilding of the hierarchy of the cdpvf grid")
    dispatchData(changeContractDrilldownCDPVF({cdpvfRebuildHierarchy: false}));
}, [useSelector((state) => state.contractDrilldownSlcCDPVF.value.cdpvfRebuildHierarchy)===true]);

    // ******************** END USE EFFECTS *******************


    // ***************** BEGIN CONTROLS ***************************

    const handleNewLevel = (from, to) => {
        addNewFilterLevel(selectorCDPid, from, to)
            .then(handleRebuildHierarchy)
    };


    const handleExtendLevel = ( to) => {
        extendLastFilterLevel(selectorCDPid, to)
            .then(handleRebuildHierarchy)
    };


    const handleAdd = () => {
        dispatchData(changeContractDrilldownCDPVF({ cdpvfGridState: false,
            cdpvfDrawerState: true, cdpvfDrawerContext: "cdpvfGrid" ,cdpvfDrawerMode: "Add"}));
        dispatchData(changeContractDataPointValueFilter({
            id:  null,
            contractDataPointId: selectorCDPid,
            parentFilterId: null,
            previousFilterId: null,
            ordinalNumber: null,
            recordLevel: null,
            dataPointId: null,
            singleValue: null,
            mockValue: null,
            fromValue: null,
            toValue: null,
            status: null,
            hierarchy: null,
            cdpvMockValue: null,
            expressionIndicator: null,
            mockExpression: null,
            mockExpressionTranslation: null,
            createdOn: null,
            createdBy: null,
            lastModifiedOn: null,
            lastModifiedBy: null
        }))
    };


    const handleEdit = () => {
        dispatchData(changeContractDrilldownCDPVF({
            cdpvfGridState: true, cdpvfDrawerState: true ,cdpvfDrawerContext: "cdpvfGrid" ,cdpvfDrawerMode: "Edit"}));
    }


    const handleClose = () => {
    dispatchData(changeContractDrilldownCDPVF({ cdpvfGridState: false}))};


    const handleRebuildHierarchy = () => {
        updateCdpvfHierarchy(selectorCDPid)
            .then(() => {fetchDrilldownCDPVF();
                });
    };


    const handleExploreCDPV = (selectedCDP, rowFull) => {
        setShowCdpvGrid(!showCdpvGrid);
        console.log("Here's the grid state upon clicking the m button");
        console.log(showCdpvGrid);
        dispatchData(changeContractDrilldownCDP({id: selectedCDP, filterId: rowFull.id}));
         dispatchData(changeContractDataPointValue({cdpvGridState: true, cdpvDrawerMode: "View"}));
        dispatchData(changeContractDrilldownCDPV({cdpvGridState: true}));
    };


    const handleAddValue = () => {
        dispatchData(changeContractDataPointValue({id: null,
                        contractDataPointId: selectorCDPid,
            contractDataPointValueFilterId: selectorCdpvfId,
            ordinalNumber: null, iterationNumber: null,
            extendInd: false, value: null, expression: null, expressionDescription: null, expressionTranslation: null,
            sourceContractDataPointValueId: null, origin: null,
            status: null, mockValue: null,
            createdOn: null, createdBy: null, lastModifiedOn: null, lastModifiedBy: null,
            cdpvDrawerMode: "Add",cdpvDrawerContext: "cdpvfGrid", cdpvDrawerState: true}));
        dispatchData(changeContractDrilldownCDPVF({ cdpvDrawerState: true, cdpvfDrawerContext: "cdpvfGrid", cdpvfGridRefresh: true }));
    };


    // const handleEditValue = () => {
    //     console.log("handleEdit");
    //     console.log("selectorCdpvCount: ", selectorCdpvCount);
    //     console.log("selectorCdpvfId", selectorCdpvfId);
    //     if(selectorCdpvCount === 1) {
    //         getCDPVbyCDPVFid(selectorCdpvfId)
    //             .then(function (res) {
    //                 console.log("handleEdit");
    //                 dispatchData(changeContractDataPointValue({cdpvCount: res.data.length}));
    //                 if (res.data.length === 1) {
    //                     console.log("my cdpv data")
    //                     console.log(res.data[0])
    //                     console.log("selected cdpv.id", res.data[0].id)
    //                     dispatchData(changeContractDataPointValue(
    //                             {
    //                                 id: res.data[0].id
    //                                 ,
    //                                 contractDataPointId: res.data[0].contractDataPointId,
    //                                 ordinalNumber: res.data[0].ordinalNumber,
    //                                 iterationNumber: res.data[0].iterationNumber,
    //                                 extendInd: res.data[0].extendInd,
    //                                 value: res.data[0].value,
    //                                 expression: res.data[0].expression,
    //                                 expressionDescription: res.data[0].expressionDescription,
    //                                 expressionTranslation: res.data[0].expressionTranslation,
    //                                 sourceContractDataPointValueId: res.data[0].sourceContractDataPointValueId,
    //                                 contractDataPointValueFilterId: res.data[0].contractDataPointValueFilterId,
    //                                 origin: res.data[0].origin,
    //                                 status: res.data[0].status,
    //                                 mockValue: res.data[0].mockValue,
    //                                 defaultValue: res.data[0].defaultValue,
    //                                 createdOn: res.data[0].createdOn,
    //                                 createdBy: res.data[0].createdBy,
    //                                 lastModifiedOn: res.data[0].lastModifiedOn,
    //                                 lastModifiedBy: res.data[0].lastModifiedBy,
    //                                 cdpvDrawerMode: "Edit", cdpvDrawerContext: "cdpvfGrid", cdpvDrawerState: true
    //                             }
    //                         )
    //                     )
    //                 }
    //             }).finally(() => {
    //             dispatchData(changeContractDrilldownCDPVF({
    //                 cdpvfDrawerState: false, cdpvfDrawerMode: "Edit",
    //                 cdpvfGridState: true, cdpvfGridRefresh: true, cdpvfCount: 1,
    //                 cdpvDrawerState: true, cdpvfDrawerContext: "cdpvfGrid", cdpvGridState: false
    //             }));
    //             console.log("edit causing update to cdpvf controls");
    //             console.log("CdpvDrawerState", controlCdpvDrawerState);
    //
    //             if (selectorCdpvCount > 1) {
    //                 dispatchData(changeContractDrilldownCDP({id: selectorCDPid}));
    //                 dispatchData(changeContractDrilldownCDPV({cdpvGridState: true}));
    //                 dispatchData(changeContractDataPointValue({cdpvGridState: true, cdpvDrawerMode: "Edit"}));
    //             }
    //         })
    //     };

        const handleEditValue = () => {
            console.log("handleEdit");
            console.log("selectorCdpvCount: ", selectorCdpvCount);
            console.log("selectorCdpvfId", selectorCdpvfId);

            if (selectorCdpvCount === 1) {
                getCDPVbyCDPVFid(selectorCdpvfId)
                    .then((res) => {
                        dispatchData(changeContractDataPointValue({ cdpvCount: res.length }));

                        if (res.length === 1) {
                            dispatchData(
                                changeContractDataPointValue({
                                    id: res[0].id,
                                    contractDataPointId: res[0].contractDataPointId,
                                    ordinalNumber: res[0].ordinalNumber,
                                    iterationNumber: res[0].iterationNumber,
                                    extendInd: res[0].extendInd,
                                    value: res[0].value,
                                    expression: res[0].expression,
                                    expressionDescription: res[0].expressionDescription,
                                    expressionTranslation: res[0].expressionTranslation,
                                    sourceContractDataPointValueId: res[0].sourceContractDataPointValueId,
                                    contractDataPointValueFilterId: res[0].contractDataPointValueFilterId,
                                    origin: res[0].origin,
                                    status: res[0].status,
                                    mockValue: res[0].mockValue,
                                    defaultValue: res[0].defaultValue,
                                    createdOn: res[0].createdOn,
                                    createdBy: res[0].createdBy,
                                    lastModifiedOn: res[0].lastModifiedOn,
                                    lastModifiedBy: res[0].lastModifiedBy,
                                    cdpvDrawerMode: "Edit",
                                    cdpvDrawerContext: "cdpvfGrid",
                                    cdpvDrawerState: true,
                                })
                            );
                        }
                    })
                    .finally(() => {
                        dispatchData(
                            changeContractDrilldownCDPVF({
                                cdpvfDrawerState: false,
                                cdpvfDrawerMode: "Edit",
                                cdpvfGridState: true,
                                cdpvfGridRefresh: true,
                                cdpvfCount: 1,
                                cdpvDrawerState: true,
                                cdpvfDrawerContext: "cdpvfGrid",
                                cdpvGridState: false,
                            })
                        );

                        console.log("edit causing update to cdpvf controls");
                        console.log("CdpvDrawerState", controlCdpvDrawerState);
                    });

                return; // prevents falling through
            }

            if (selectorCdpvCount > 1) {
                dispatchData(changeContractDrilldownCDP({ id: selectorCDPid }));
                dispatchData(changeContractDrilldownCDPV({ cdpvGridState: true }));
                dispatchData(changeContractDataPointValue({ cdpvGridState: true, cdpvDrawerMode: "Edit" }));
            }
        };
    // ==== begin CDPD delete

    // const handleDeleteCdp = () => {
    //     console.log("deleting this contract data point id");
    //     console.log(selectorContractDataPointId);
    //     deleteContractCDP(selectorContractDataPointId).then(
    //         orderCDPinCS(selectorContractSectionId)).then(
    //         orderCDPinCS(selectorContractSectionId)).then(
    //         dispatchData(changeContractDataPoint({cdpGridRefresh: true})))
    // };

    const [confirmSingleCdpvDeleteOpen, setConfirmSingleCdpvDeleteOpen] = React.useState(false);

    const handleConfirmSingleCdpvDeleteClose = () => setConfirmSingleCdpvDeleteOpen(false);

    const handleDeleteCdpv = () => {
        if(selectorCdpvCount === 1) {
            setConfirmSingleCdpvDeleteOpen(true);
            setAnchorEl(null);
        }
        if(selectorCdpvCount > 1) {
            handleMenuClose();
            dispatchData(changeContractDrilldownCDP({id: selectorContractDataPointId}));
            dispatchData(changeContractDrilldownCDPV({cdpvGridState: true}));
            dispatchData(changeContractDataPointValue({cdpvGridState: true, cdpvDrawerMode: "Delete"}));
        }
    };


    const handleConfirmSingleCdpvDelete = () => {
        console.log("deleting this contract data point value id");
        console.log(selectorCdpvId);
        deleteContractDataPointValue(selectorCdpvId)
            // orderCDPinCS(selectorContractSectionId)).then(
            // orderCDPinCS(selectorContractSectionId)).then(
            .then(() => {
                dispatchData(changeContractDataPoint({cdpGridRefresh: true}))
                setConfirmSingleCdpvDeleteOpen(false);
            });
        // console.log("contract to be deleted = ", selectorContractId2);
        // setConfirmOpen(false);
    };

    // ==== end CDPD delete


    // ==== begin CDPDF delete

    // const handleDeleteCdp = () => {
    //     console.log("deleting this contract data point id");
    //     console.log(selectorContractDataPointId);
    //     deleteContractCDP(selectorContractDataPointId).then(
    //         orderCDPinCS(selectorContractSectionId)).then(
    //         orderCDPinCS(selectorContractSectionId)).then(
    //         dispatchData(changeContractDataPoint({cdpGridRefresh: true})))
    // };

    const [confirmSingleCdpvfDeleteOpen, setConfirmSingleCdpvfDeleteOpen] = React.useState(false);

    const handleConfirmSingleCdpvfDeleteClose = () => setConfirmSingleCdpvfDeleteOpen(false);

    const handleDeleteCdpvf = () => {
        console.log("selectorCdpvCount = ",selectorCdpvCount);
        if(selectorCdpvCount === 0 ){
            setConfirmSingleCdpvfDeleteOpen(true);
            setAnchorEl(null);
        }


    };


    const handleConfirmSingleCdpvfDelete = () => {
        console.log("deleting this contract data point value filter id");
        console.log(selectorCdpvfId);
        deleteContractDataPointValueFilter(selectorCdpvfId)
            // orderCDPinCS(selectorContractSectionId)).then(
            // orderCDPinCS(selectorContractSectionId)).then(

            .then(() => {
                setConfirmSingleCdpvfDeleteOpen(false);
                dispatchData(changeContractDataPoint({cdpGridRefresh: true}));
            });
        // console.log("contract to be deleted = ", selectorContractId2);
        // setConfirmOpen(false);
    };

    // ==== end CDPVF delete




    const removeContractDataPointValueFilter = (selectorCdpvfId,callback) => {
        deleteContractDataPointValueFilter(selectorCdpvfId).then(() => {
            dispatchData(changeCrudSnackbar({crudOpen: true, crudSeverity: "success", crudMessage: "Record deleted"}));
        })
    };


    const removeContractDataPointValue = (selectorCDPid,callback) => {
        deleteContractDataPointValue(selectorCDPid).then(() => {
            dispatchData(changeCrudSnackbar({crudOpen: true, crudSeverity: "success", crudMessage: "Record deleted"}));
        })
    };


        const handleMousedRow = (allCDPVFs) => {
        console.log('Moused over the More icon.');
        console.log(allCDPVFs);
            dispatchData(changeContractDrilldownCDPVF({
            id: allCDPVFs.id,
            contractDataPointId: allCDPVFs.contractDataPointId,
            contractDataPointValueId: allCDPVFs.contractDataPointValueId,
            parentFilterId: allCDPVFs.parentFilterId,
            previousFilterId: allCDPVFs.previousFilterId,
            ordinalNumber: allCDPVFs.ordinalNumber,
            recordLevel: allCDPVFs.recordLevel,
            dataPointId: allCDPVFs.dataPointId,
            singleValue: allCDPVFs.singleValue,
            singleValueNumber: allCDPVFs.singleValueNumber,
            fromValue: allCDPVFs.fromValue,
            toValue: allCDPVFs.toValue,
            status: allCDPVFs.status,
            hierarchy: allCDPVFs.hierarchy,
            cdpvMockValue: allCDPVFs.cdpvMockValue,
            expressionIndicator: allCDPVFs.expressionIndicator,
            mockExpression: allCDPVFs.mockExpression,
            mockExpressionTranslation: allCDPVFs.mockExpressionTranslation,
            createdOn: allCDPVFs.createdOn,
            createdBy: allCDPVFs.createdBy,
            lastModifiedOn: allCDPVFs.lastModifiedOn,
            lastModifiedBy: allCDPVFs.lastModifiedBy,
            expressionIndicatorOld: allCDPVFs.expressionIndicatorOld,
            mockExpressionOld: allCDPVFs.mockExpressionOld,
            mockExpressionTranslationOld: allCDPVFs.mockExpressionTranslationOld,
            cdpvCount: allCDPVFs.cdpvCount,
            dataPointName: allCDPVFs.dataPointName,
            dataType: allCDPVFs.dataType,
            displaySingleValue: allCDPVFs.displaySingleValue,
            displayFromValue: allCDPVFs.displayFromValue,
            displayToValue: allCDPVFs.displayToValue,
            cdpDataPointId: allCDPVFs.cdpDataPointId,
            cdpDataPointName: allCDPVFs.cdpDataPointName,
            cdpDataType: allCDPVFs.cdpDataType,
            mockOrigin: allCDPVFs.mockOrigin,
            cdpvValue: allCDPVFs.cdpvValue,
            expression: allCDPVFs.expression,
            expressionTranslation:  allCDPVFs.expressionTranslation,
            expressionDescription:  allCDPVFs.expressionDescription,
            mockValue: allCDPVFs.mockValue,
            parentDataPointId:  allCDPVFs.parentDataPointId,
            parentDataPointName:  allCDPVFs.parentDataPointName,
            parentDataType:  allCDPVFs.parentDataType,
            parentDisplaySingleValue:  allCDPVFs.parentDisplaySingleValue,
            parentDisplayFromValue:  allCDPVFs.parentDisplayFromValue,
            parentDisplayToValue:  allCDPVFs.parentDisplayToValue,
                cdpvId: allCDPVFs.cdpvId,
        }))
        getCDPVbyCDPVFid(allCDPVFs.id)
            .then(function (res) {
                dispatchData(changeContractDataPointValue({cdpvCount: res.length}));
                console.log("my cdpv data from mouseover")
                console.log("my cdpv data length is " + res.length);
                if (res.length === 1) {
                    // console.log(res.data[0])
                    dispatchData(changeContractDataPointValue(
                            {
                                id: res[0].id
                                ,
                                contractDataPointId: res[0].contractDataPointId,
                                ordinalNumber: res[0].ordinalNumber,
                                iterationNumber: res[0].iterationNumber,
                                extendInd: res[0].extendInd,
                                value: res[0].value,
                                expression: res[0].expression,
                                expressionDescription: res[0].expressionDescription,
                                expressionTranslation: res[0].expressionTranslation,
                                sourceContractDataPointValueId: res[0].sourceContractDataPointValueId,
                                contractDataPointValueFilterId: res[0].contractDataPointValueFilterId,
                                origin: res[0].origin,
                                status: res[0].status,
                                mockValue: res[0].mockValue,
                                defaultValue: res[0].defaultValue,
                                createdOn: res[0].createdOn,
                                createdBy: res[0].createdBy,
                                lastModifiedOn: res[0].lastModifiedOn,
                                lastModifiedBy: res[0].lastModifiedBy
                            }
                        )
                    )
                }
            });
        console.log("my cdpv.cpdvf.id")
    };


    function closeCDPVFDrawer() {
        console.log("CDPVF grid closed by closeCDPVFDrawer function in ContractDataPointValueFilterGrid");
        dispatchData(changeContractDrilldownCDPVF({cdpvfGridState: false}));
    };

    // *************** END CONTROLS *******************************


    // ***************** BEGIN COLUMNS ***************************

    const columns = fetchDrilldownCDPVF => [

        {
            field: "cDPVFExplore",
            headerName: '',
            width: 60,
            padding: 0,
            margin: 0,
            sortable: false,
            menu: false,
            filter: false,
            renderCell: (allCDPVFs) =>{
                return (
                    <div
                        onMouseOver = {() => handleMousedRow(allCDPVFs.row)}
                    >
                    <Tooltip title={`Click to see actions for record ${allCDPVFs.row.id}`}
                        // onClick= {() => dispatchContractSection(changeContractSection({id: drilldownCS.row.id}))}
                    >
                        {/*<p>hi</p>*/}
                        <CdpvfGridCrudMenu/>
                        {/*<MoreHorizIcon fontSize={'small'} onClick= {() => handleControls()}/>*/}
                    </Tooltip>
                    </div>
                );

            }
        },
        {    field: 'id',
            headerName: 'ID',
            description: '',
            sortable: false,
            width: 60,
            hide: true,
        },
        {    field: 'contractDataPointId',
            headerName: 'CDP ID',
            description: '',
            sortable: false,
            width: 60,
            hide: true,
        },
        {    field: 'parentFilterId',
            headerName: 'Parent',
            description: '',
            sortable: false,
            width: 60,
            hide: true,
        },
        {    field: 'previousFilterId',
            headerName: 'previous',
            description: '',
            sortable: false,
            width: 60,
            hide: true,
        },
        {
            field: 'recordLevel',
            headerName: 'Level',
            description: '',
            sortable: false,
            hide: true,
            width: 60,

        },
        {
            field: 'ordinalNumber',
            headerName: '#',
            description: '',
            sortable: false,
            hide: true,
            width: 60,
        },
        {
            field: 'dataPointId',
            headerName: 'dp.id',
            description: '',
            sortable: false,
            width: 80,
            hide: true,
        },
        {
            field: 'dataPointName',
            headerName: 'Name',
            renderCell: (allCDPVFs) => {
                return <Tooltip enterDelay={1000} style={{cursor:'pointer'}} title={<span style={{whiteSpace: 'pre-line'}}>
                                        {"name: " + allCDPVFs.row.dataPointName +
                                            "\nid: " + allCDPVFs.row.id +
                                            "\nparent: " + allCDPVFs.row.parentFilterId +
                                            "\nprevious: " + allCDPVFs.row.previousFilterId +
                                            "\nlevel: " + allCDPVFs.row.recordLevel +
                                            "\norder: " + allCDPVFs.row.ordinalNumber +
                                            "\ncdp id: " + allCDPVFs.row.contractDataPointId
                                        }  </span>}><div className="rowitem">{allCDPVFs.row.dataPointName}</div>
                </Tooltip>;},
            description: '',
            sortable: true,
            width: 150,
        },
        {
            field: 'displaySingleValue',
            headerName: 'Single Value',
            renderCell: (allCDPVFs) => {
                return <Tooltip enterDelay={1000} style={{cursor:'pointer'}} title={<span style={{whiteSpace: 'pre-line'}}>
                                        {"name: " + allCDPVFs.row.displaySingleValue +
                                            "\nid: " + allCDPVFs.row.singleValue
                                        }  </span>}><div className="rowitem">{allCDPVFs.row.displaySingleValue}</div>
                </Tooltip>;},
            description: '',
            sortable: false,
            width: 300,
        },
        {
            field: 'displayFromValue',
            headerName: 'From',
            description: '',
            sortable: false,
            width: 100,
        },
        {
            field: 'displayToValue',
            headerName: 'To',
            description: '',
            sortable: false,
            width: 100,
        },
        {
            field: 'mockValue',
            headerName: 'Returned Value',
            description: '',
            sortable: false,
            width: 300,
            renderCell: (allCDPVFs) =>
            {
                   if(allCDPVFs.row.cdpvCount === 1 &&
                       allCDPVFs.row.cdpvValue !== '' && allCDPVFs.row.cdpvValue !== null
                   )
                {
                    return <Tooltip  placement={'right-start'}  enterDelay={1000}  title={<span style={{whiteSpace: 'pre-line'}}>
                    {"A single value is present" +
                        // "\nId: " + allCDPVFs.row.cdpvValue
                        "\nValue: " + allCDPVFs.row.cdpvValue                    }
                </span>}>
                        <div>{allCDPVFs.row.mockValue}</div>
                    </Tooltip>;
                }
                if(allCDPVFs.row.cdpvCount === 1 &&
                     allCDPVFs.row.cdpvDefaultValue !== '' && allCDPVFs.row.cdpvDefaultValue !== null
                && (allCDPVFs.row.cdpvValue === '' || allCDPVFs.row.cdpvValue !== null)
                )
                {
                    return (
                        <Tooltip   enterDelay={1000}  title={"Default value is present."}>
                            <Avatar
                                onClick= {() => handleExploreCDPV(allCDPVFs.row.contractDataPointId,  allCDPVFs.row)}
                                sx={{ height:20, width: 20, fontSize: 16, bgcolor: blue[500] }}>d</Avatar>
                        </Tooltip>)
                }
                if(allCDPVFs.row.cdpvCount > 1){
                    return (
                        <Tooltip   enterDelay={1000}  title={"Multiple values.  Click to see all."}>
                            <Avatar
                                onClick= {() => handleExploreCDPV(allCDPVFs.row.contractDataPointId,  allCDPVFs.row)}
                                sx={{ height:20, width: 20, fontSize: 16, bgcolor: deepPurple[500] }}>m</Avatar>
                        </Tooltip>)}
            },
        },
        {
            field: 'hierarchy',
            headerName: 'hierarchy',
            description: '',
            sortable: false,
            hide: true,
            width: 60,
        },

        {
            field: GRID_DETAIL_PANEL_TOGGLE_FIELD,
            headerName: '',
            renderCell: (allCDPVFs) =>
            {
                if((allCDPVFs.row.expression !== null) && (allCDPVFs.row.expression !== '' ) ){
                    return (
                        <Tooltip title={"Value comes from an expression.  Click to view."}>
                            <Avatar sx={{ height:20, width: 20, fontSize: 16, bgcolor: deepOrange[500] }}>e</Avatar>
                        </Tooltip>
                    )}
            },
            description: '',
            sortable: false,
            width: 50,
        },
    ];

    // *************** END COLUMNS *******************************


    // ****************** BEGIN TOOLBAR ****************************

    const CustomToolbar = ({ onAddNext, onExtendNext }) => {
        const form1 = useForm({
            defaultValues: {
                addNewFrom: "",
                addNewTo: ""
            }
        });

        const form2 = useForm({
            defaultValues: {
                extendNewTo: ""
            }
        });

        const onSubmitForm1 = form1.handleSubmit(({ addNewFrom, addNewTo }) => {
            handleNewLevel(addNewFrom, addNewTo);
        });

        const onSubmitForm2 = form2.handleSubmit(({ extendNewTo }) => {
            handleExtendLevel(extendNewTo);
        });


        return (

            <GridToolbarContainer>

                <Box sx= {{height: 70,
                    flexGrow: 1}}>
                    <Stack direction={'row'} spacing={3} alignItems="center">
                        <Tooltip title={"Add Filter"}>
                            <AddCircleOutlineIcon
                                sx={{mr: 3, mb: .5, verticalAlign: 'bottom'}}
                                fontSize="medium" color={'primary'}
                                onClick={() => handleAdd()}/>
                        </Tooltip>
                        <Box sx={{width: 30}}/>
                        <form onSubmit={onSubmitForm2}>
                            <TextField
                                sx={{verticalAlign: 'top'}}
                                id="extendNewTo"
                                name="extendNewTo"
                                label="New To"
                                size="small"
                                variant='standard'
                                {...form2.register("extendNewTo")}
                            />
                            <Tooltip title={"Extend Last Filter Set"}>
                                <KeyboardArrowRightIcon
                                    sx={{mr: 3, mb: .5, verticalAlign: 'bottom'}}
                                    fontSize="medium" color={'primary'}
                                    style={{cursor: 'pointer'}}
                                    onClick={onSubmitForm2}
                                />
                            </Tooltip>
                        </form>
                        <form onSubmit={onSubmitForm1}>
                            <Box sx={{width: 40}}/>
                            <Stack direction={'row'} spacing={3} alignItems="center">
                                <TextField
                                    id="addNewFrom"
                                    name="addNewFrom"
                                    label="New From"
                                    size="small"
                                    variant='standard'
                                    {...form1.register("addNewFrom")}
                                />
                                <TextField
                                    id="addNewTo"
                                    name="addNewTo"
                                    label="New To"
                                    size="small"
                                    variant='standard'
                                    {...form1.register("addNewTo")}
                                />

                                <Tooltip title={"Add Next Filter Set"}>
                                    <KeyboardDoubleArrowRightIcon
                                        style={{cursor: 'pointer'}}
                                        sx={{mr: 3, mb: .5, verticalAlign: 'bottom'}}
                                        fontSize="medium" color={'primary'}
                                        onClick={onSubmitForm1}
                                    />
                                </Tooltip>
                            </Stack>
                        </form>
                    </Stack>
                    <GridToolbarColumnsButton />
                    <GridToolbarDensitySelector />

                </Box>
                <Box sx= {{
                    flexGrow: 1}}>
                </Box>
                <Box sx= {{
                    flexGrow: 1,
                    display: { xs: 'none', md: 'flex' },
                    alignContent: 'flex-end',
                    justifyContent: 'flex-end',
                    ml:30
                }}>
                    <GridToolbarExport  />
                </Box>
            </GridToolbarContainer>
        );
    }

    // ****************** END TOOLBAR ****************************


    // ***************** BEGIN MENU ***************************

    function CdpvfGridCrudMenu() {

        const [anchorEl, setAnchorEl] = React.useState(null);
        // const [anchorEl, setAnchorEl] = React.useState(false);

        const isMenuOpen = Boolean(anchorEl);
        // const isMenuOpen = anchorEl;
        //
        const handleCrudMenuOpen = (event) => {
            console.log("Crud Menu open.")
            console.log("event.currentTarget:", event.currentTarget)
            setAnchorEl(event.currentTarget);
        };


        function handleMenuClose()  {
            // setAnchorEl(false);
            setAnchorEl(null);
        };

        const handleMoveUp = () => {

        };

        const handleMoveDown = () => {

        };

        const handleMoveIn = () => {

        };

        const handleMoveOut = () => {

        };

        const handleClone = () => {

        };



        const crudId = 'primary-search-account-menu';

        const renderMenu = (

            <Menu
                anchorEl={anchorEl}
                anchorOrigin={{
                    vertical: 'top',
                    horizontal: 'right',
                }}
                id={crudId}
                keepMounted
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'right',
                }}
                open={isMenuOpen}
                onClose={handleMenuClose}
            >
                <MenuItem
                    onClick={handleEdit}
                >
                    <ListItemIcon>
                        <EditIcon fontSize="small" />
                    </ListItemIcon>
                    <ListItemText>Edit Filter</ListItemText>
                </MenuItem>
                <MenuItem
                    onClick={handleDeleteCdpvf}>
                    <ListItemIcon>
                        <DeleteOutlineIcon fontSize="small" />
                    </ListItemIcon>
                    <ListItemText>Delete Filter</ListItemText>
                </MenuItem>

                <Dialog open={confirmSingleCdpvfDeleteOpen} onClose={handleConfirmSingleCdpvfDeleteClose}>
                    <DialogTitle>Confirm Contract Data Point Value Filter Delete</DialogTitle>
                    <DialogContent>
                        <DialogContentText>
                            Are you sure you want to delete this Contract Data Point Value Filter? This action cannot be undone.
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={handleConfirmSingleCdpvfDeleteClose} color="primary">
                            Cancel
                        </Button>
                        <Button onClick={handleConfirmSingleCdpvfDelete} color="error">
                            Delete
                        </Button>
                    </DialogActions>
                </Dialog>

                <MenuItem
                    onClick={handleAddValue}>
                    <ListItemIcon>
                        <AddCircleOutlineIcon fontSize="small" />
                    </ListItemIcon>
                    <ListItemText>Add Value</ListItemText>
                </MenuItem>
                <MenuItem
                    onClick={handleEditValue}>
                    <ListItemIcon>
                        <EditIcon fontSize="small" />
                    </ListItemIcon>
                    <ListItemText>Edit Value</ListItemText>
                </MenuItem>
                <MenuItem
                    onClick={handleDeleteCdpv}>
                    <ListItemIcon>
                        <DeleteOutlineIcon fontSize="small" />
                    </ListItemIcon>
                    <ListItemText>Delete Value</ListItemText>
                </MenuItem>

                <Dialog open={confirmSingleCdpvDeleteOpen} onClose={handleConfirmSingleCdpvDeleteClose}>
                    <DialogTitle>Confirm Contract Data Point Value Delete</DialogTitle>
                    <DialogContent>
                        <DialogContentText>
                            Are you sure you want to delete this Contract Data Point Value? This action cannot be undone.
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={handleConfirmSingleCdpvDeleteClose} color="primary">
                            Cancel
                        </Button>
                        <Button onClick={handleConfirmSingleCdpvDelete} color="error">
                            Delete
                        </Button>
                    </DialogActions>
                </Dialog>

            </Menu>
        );

        return (
            <div>
                <IconButton
                    size="large"
                    edge="end"
                    aria-label="account of current user"
                    aria-controls={crudId}
                    aria-haspopup="true"
                    onClick={handleCrudMenuOpen}
                    color="inherit"
                >
                    <MoreVertIcon  color="primary" fontSize="small"/>
                </IconButton>
                {renderMenu}
            </div>
        );
    }

    // ***************** END MENU ***************************



    function onChange(pagination, filters, sorter, extra) {
        console.log('params', pagination, filters, sorter, extra);
    }

    const getTreeDataPath = (allCDPVFs) => allCDPVFs.hierarchy.split(',');


    const getDetailPanelHeight = React.useCallback(() => 300, []);


    function MiniDrawer() {
        return (
            <Drawer sx={{zIndex: theme => theme.zIndex.drawer + 1, height: 200, width: 200}}
                    anchor="right"
                    open={controlCdpvDrawerState}>Hello</Drawer>
        )
    };


    // ****************** BEGIN RETURN ****************************

    return (
            <div>
                <div>
                    {useSelector((state) => state.contractDataPointValueSlc.value.cdpvDrawerContext) === "cdpvfGrid" &&
                        <ContractDataPointValueDrawer/>
                        // <MiniDrawer/>
                        //     <Alert>Drawer Triggered</Alert>
                    }
                    {useSelector((state) => state.contractDrilldownSlcCDPVF.value.cdpvfDrawerContext) === "cdpvfGrid" &&
                    // {useSelector((state) => state.contractDataPointValueFilterSlc.value.cdpvfDrawerContext) === "cdpvfGrid" &&
                        <ContractDataPointValueFilterDrawer/>}
                </div>
                <Drawer sx={{height: "100%", width: 800}}
                        anchor='right'
                        open={useSelector((state) => state.contractDrilldownSlcCDPVF.value.cdpvfGridState)}
                        // open={useSelector((state) => state.contractDataPointValueFilterSlc.value.cdpvfGridState)}
                        onClose={closeCDPVFDrawer}
                >

                    <Box sx={{
                        height: 800, width: 1500,
                        '& .level--1': {backgroundColor: "rgb(30,144,255)"},//https://html-color.codes/blue dodger blue
                        '& .level--2': {backgroundColor: "rgb(69,177,232)"},//https://html-color.codes/blue picton blue
                        '& .level--3': {backgroundColor: "rgb(135,206,250)"},//https://html-color.codes/blue lightskyblue
                        '& .level--4': {backgroundColor: "rgb(137,207,240)"},//https://html-color.codes/blue baby blue
                        '& .level--5': {backgroundColor: "rgb(173,216,230)"},//https://html-color.codes/blue light blue
                        '& .level--6': {backgroundColor: "rgb(135,206,235)"},//https://html-color.codes/blue skyblue
                        '& .level--7': {backgroundColor: "rgb(231,254,255)"},//https://html-color.codes/blue bubbles
                        '& .level--8': {backgroundColor: "rgb(244,240,236)"},//https://html-color.codes/grey isabelline
                        '& .level--9': {backgroundColor: "rgb(250,250,250)"},//custom
                        '& .level--10': {backgroundColor: "rgb(255,255,255)"},//custom
                    }}>
                        <br/>

                        <h2 style={{paddingLeft: 15, cursor: 'pointer'}} onClick={() => handleClose()}>Contract Data
                            Point Value Filters</h2>

                        <Typography sx={{
                            fontWeight: 'bold'
                        }}
                                    style={{
                                        paddingLeft: 15, cursor: 'pointer'
                                    }} onClick={() => handleRebuildHierarchy()}>{selectorCdpDataPointName}</Typography>
                        <br/>
                        {/*<br/>*/}
                        {/*<br/>*/}
                        <IconButton
                            onClick={() => setShowToolbar(prev => !prev)}
                            sx={{
                                transform: showToolbar ? 'rotate(90deg)' : 'rotate(0deg)',
                                transition: 'transform 0.3s ease-in-out'
                            }}
                        >
                            <KeyboardArrowRightIcon />
                        </IconButton>
                        {/*{useSelector((state) => state.contractDataPointValueFilterSlc.value.cdpvfGridState) &&*/}
                        {useSelector((state) => state.contractDrilldownSlcCDPVF.value.cdpvfGridState) &&
                            <DataGridPro
                                treeData
                                style={{height: 600, width: 1500}}
                                aria-label={"ContractDataPointValueFilters2"}
                                rows={allCDPVFs}
                                sx={{
                                    '& .MuiDataGrid-detailPanel': {
                                        backgroundColor: deepOrange[100],
                                    },
                                    // '& .level--1': { backgroundColor: "rgb(30,144,255)" },
                                    // ... // your other styles
                                }}
                                disableDensitySelector={true}
                                disableColumnSelector={true}
                                columns={columns(fetchDrilldownCDPVF)}
                                getTreeDataPath={getTreeDataPath}
                                getRowClassName={(allCDPVFs) => `level--${allCDPVFs.row.recordLevel}`}
                                density={"compact"}
                                pageSize={20}
                                rowsPerPageOptions={[20]}
                                rowThreshold={0}
                                getDetailPanelHeight={getDetailPanelHeight}
                                // components={{
                                //     Toolbar: showToolbar ? CustomToolbar : undefined
                                //     // Toolbar: CustomToolbar,
                                // }}
                                components={{
                                    Toolbar: showToolbar
                                        ? () => (
                                            <CustomToolbar
                                                onAddNext={handleNewLevel}
                                                onExtendLevel={handleExtendLevel}
                                            />
                                        )
                                        : undefined
                                }}
                                // getDetailPanelContent={({row}) => (
                                //     <Box sx={{
                                //         p: 2,
                                //         bgcolor: deepOrange[100]
                                //     }}>
                                //         {`Expression: ${row.expression}`}
                                //         <br/>
                                //         <br/>
                                //         {`Translation: ${row.expressionTranslation}`}
                                //     </Box>
                                // )}
                                getDetailPanelContent={({ row }) => (
                                    <Box sx={{ p: 2,
                                        bgcolor: deepOrange[100]
                                        // backgroundColor: "rgb(255,204,153)"
                                    }}>
                                        <Box sx={{ml: 2}}>
                                            <strong>Expression:</strong> {row.expression}
                                        </Box>
                                        <br/>
                                        <Box sx={{ml: 2}}>
                                            <strong>Translation:</strong> {row.expressionTranslation}
                                        </Box>
                                        <br/>
                                        <Box sx={{ml: 2}}>
                                            <strong>Description:</strong> {row.expressionDescription}
                                        </Box>
                                    </Box>
                                )}
                            />}
                    </Box>
                </Drawer>
            </div>
        );

    // ****************** END RETURN ****************************


}




